import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { movieSortValue } from '../../contants/movieSortValue';

export const fetchHomeMovies = createAsyncThunk(
  'movies/FETCH_MOVIES',
  async (moviesObj, thunkAPI) => {
    try {
      const getMovies = await fetch(
        `https://api.themoviedb.org/3/discover/movie?include_adult=false&language=en-US&page=${moviesObj.page}&sort_by=${moviesObj.sorted}`,
        { signal: thunkAPI.signal, headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_TMDB_ID_AUTHORIZATION}`,
        }}
      );
      const data = await getMovies.json();
      return data;
    } catch (error) {
      throw Error('404 test');
    }
  }
);

export const fetchGenreMovies = createAsyncThunk(
  'movies/FETCH_GENRE_MOVIES',
  async (moviesObj, thunkAPI) => {
    try {
      const getMovies = await fetch(
        `https://api.themoviedb.org/3/discover/movie?include_adult=false&language=en-US&page=${moviesObj.pageId}&sort_by=${moviesObj.sorted}&with_genres=${moviesObj.genreId}`,
        { signal: thunkAPI.signal, headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_TMDB_ID_AUTHORIZATION}`,
        }}
      );
      const data = await getMovies.json();
      window.scrollTo(0, 0)
      return {
        movies: data,
        genreId: moviesObj.genreId,
      };
    } catch (error) {
      window.scrollTo(0, 0);
      throw Error('404 test');
    }
  }
);

const moviesSlice = createSlice({
  name: 'movies',
  initialState: {
    movies: [],
    isLoading: false,
    sorted: movieSortValue.popularity,
    genreId: 28,
    first_list: 1,
    current_page: 1,
    totalPage: null,
    total_list_displayed: 4,
    TMDB_MAX_PAGINATION: 500,
    error: {},
  },
  reducers: {
    SORTBY_POPULAR: (state) => {
      state.sorted = movieSortValue.popularity;
    },
    SORTBY_RATED: (state) => {
      state.sorted = movieSortValue.top_rated;
    },
    SORTBY_LATEST: (state) => {
      state.sorted = movieSortValue.now_playing;
    },
    SET_GENRE: (state, action) => {
      state.genreId = action.payload.id;
    },
    resetState: (state) => {
      state.isLoading = false;
      state.sorted = movieSortValue.popularity;
      state.movies = [];
      state.genreId = 28;
      state.totalPage = null;
      state.current_page = 1;
      state.error = {};
    },
  },
  extraReducers: {
    [fetchHomeMovies.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchHomeMovies.rejected]: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    [fetchHomeMovies.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.movies = action.payload.results;
      state.totalPage = action.payload.total_pages > state.TMDB_MAX_PAGINATION ? state.TMDB_MAX_PAGINATION : action.payload.total_pages;
      state.current_page = action.payload.page;
    },
    [fetchGenreMovies.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchGenreMovies.rejected]: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    [fetchGenreMovies.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.movies = action.payload.movies.results;
      state.genreId = action.payload.genreId;
      state.totalPage = action.payload.movies.total_pages > state.TMDB_MAX_PAGINATION ? state.TMDB_MAX_PAGINATION : action.payload.movies.total_pages;
      state.current_page = action.payload.movies.page;
    },
  },
});

const {
  SORTBY_POPULAR,
  SORTBY_RATED,
  SORTBY_LATEST,
  SET_GENRE,
  resetState,
} = moviesSlice.actions;

const onSortPopular = () => ({ type: SORTBY_POPULAR.type });
const onSortRated = () => ({ type: SORTBY_RATED.type });
const onSortLatest = () => ({ type: SORTBY_LATEST.type });

const onSetGenre = (id) => SET_GENRE({ id });

// reset the state
const onResetState = () => resetState();

export {
  onSortPopular,
  onSortRated,
  onSortLatest,
  onResetState,
  onSetGenre,
};
export default moviesSlice.reducer;
